import './NoInternetMessage.scss';

import { useState, useCallback, useEffect } from 'react';

function NoInternetMessage() {
  const [visible, setVisible] = useState<boolean>(false);
  const [scale, setScale] = useState<boolean>(false);

  const onScreenClick = useCallback(() => {
    setScale(true);
    setTimeout(() => {
      setScale(false);
    }, 250);
  }, []);

  useEffect(() => {
    window.addEventListener('online', () => setVisible(false));
    window.addEventListener('offline', () => setVisible(true));

    setVisible(!window.navigator.onLine);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className={`no-internet-message ${scale ? 'scale' : ''}`} onClick={onScreenClick}>
      <div className="no-internet-message-popup">
        <div className="no-internet-message-emoji">🤕</div>
        <div className="no-internet-message-texts">
          <div className="no-internet-message-title">Ooops! You are not connected to the internet.</div>
          <div className="no-internet-message-text">
            Please check your network connection or go home. And don't disturb developers, there are sleeping
            right now.
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoInternetMessage;
